/**
 * Aggregates complex-rubric rows (functionality + aesthetics) across all groups.
 */
export function buildComplexSectionStats(groups, sectionKey) {
  const basicStats = {};
  groups.forEach((g) => {
    (g[sectionKey] || []).forEach((f) => {
      const A = parseFloat(f.aesthetics);
      const F = parseFloat(f.functionality);
      const worth = parseFloat(f.worth) || 0;
      if (!isNaN(A) && !isNaN(F)) {
        const aesWeight = f.aestheticsBonus ? 0.3 : 0.2;
        const percentage = 0.8 * F + aesWeight * A;
        if (!basicStats[f.name]) {
          basicStats[f.name] = { totalPct: 0, count: 0, worth };
        }
        basicStats[f.name].totalPct += percentage;
        basicStats[f.name].count += 1;
      }
    });
  });
  return Object.keys(basicStats).map((name) => ({
    name,
    avg: basicStats[name].count
      ? (basicStats[name].totalPct / basicStats[name].count).toFixed(2)
      : '0.00',
    count: basicStats[name].count,
    worth: basicStats[name].worth,
  }));
}

/** Aggregates basic-feature rubric rows across all groups for the analysis table. */
export function buildBasicFeatureStats(groups) {
  return buildComplexSectionStats(groups, 'basicFeatures');
}

export function buildBonusStats(groups) {
  return buildComplexSectionStats(groups, 'bonus');
}
